import Alerts from '@shared/components/Alerts.tsx';
import { MembershipPageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import MembershipInformationCard from '@my-pages/features/membership/components/MembershipInformationCard.tsx';
import SectionCard from '@my-pages/features/membership/components/SectionCard.tsx';
import Assignments from '@my-pages/features/membership/components/Assignments.tsx';
import Feature from "@shared/features/feature-flags/components/Feature.tsx";
import {FeatureFlag} from "@shared/_legacy/api/umbraco-api";
import MembershipCard from "@my-pages/features/membership/components/MembershipCard.tsx";

interface IMembershipPage {
    content: MembershipPageContentResponseModel;
}

const MembershipPage = ({ content }: IMembershipPage) => {
    return (
        <>
            <h1 className='page-title'>Medlemskap &amp; uppdrag</h1>
            <div className='slide-up-fade-in'>
                {content?.properties?.importantMessages && (
                    <div className='mb-4'>
                        <Alerts alerts={content?.properties?.importantMessages} />
                    </div>
                )}
                <div className='row'>
                    <div className='col-md-6'>
                        <MembershipInformationCard />
                    </div>
                    <div className='col-md-6'>
                        <SectionCard />
                    </div>
                    <div className='col-md-6'>
                        <Assignments />
                    </div>
                </div>
            </div>
            <Feature feature={FeatureFlag.MEMBERSHIP_CARD}>
                <MembershipCard />
            </Feature>
        </>
    );
};

export default MembershipPage;
